import Keycloak from 'keycloak-js/dist/keycloak.js'
import configs from '@/plugins/configs'

const keycloak = new Keycloak({
  url: configs.keycloakurl,
  realm: configs.keycloakrealm,
  clientId: configs.keycloakclientId
})

export function initializeKeycloak (onSuccess) {
  keycloak.init({ onLoad: configs.keycloakonLoad, checkLoginIframe: false }).then(authenticated => {
    if (authenticated) {
      onSuccess()
    } else {
      console.warn('Not authenticated')
    }
  }).catch(console.error)
}

export default keycloak
